<template>
  <main class="news page-main">
    <section class="page-heading-wrap" data-style="show">
      <h3 class="page-heading">{{ $t('menuNewsroom.newsroom') }}</h3>
    </section>

    <section class="search-form-wrap" data-style="show">
      <div class="form-control-container form-search">
        <span class="form-control-wrap form-control-active">
          <input
            ref="search"
            v-model="word"
            type="search"
            class="form-control"
            :placeholder="$t('search.placeholder')"
            @keyup.enter="search"
          >
          <button
            v-if="word"
            type="button"
            class="btn-delete"
            @click="onRemoveWord"
          ><icon-delete /></button>
        </span>
        <button type="button" class="btn-search" @click="search">
          <icon-search />
        </button>
      </div>
    </section>

    <router-view :tab-list="tabList" :list-size="listSize" />
  </main>
</template>
<script>
import observer from '@/mixins/observer'

export default {
  components: {
    iconSearch: () => import('@/static/svg/search.svg'),
    iconDelete: () => import('@/static/svg/delete.svg')
  },
  mixins: [observer],
  data () {
    return {
      word: '',
      tabList: [
        // name은 번역에서 가져옴 tab components에서 번역 바인딩
        {
          path: 'NewsroomReport',
          name: 'menuNewsroom.press',
          query: { page: 1 }
        },
        {
          path: 'NewsroomMedia',
          name: 'menuNewsroom.release',
          query: { page: 1 }
        },
        {
          path: 'NewsroomFact',
          name: 'menuNewsroom.factCheck',
          query: { page: 1 }
        }
      ],
      listSize: 10
    }
  },
  created () {
    this.word = this.$route.query.word
  },
  mounted () {
    const isMobile = this.detectMobileDevice(window.navigator.userAgent)
    if (isMobile) {
      this.listSize = 20
    } else {
      this.listSize = 10
    }
  },
  methods: {
    search () {
      if (this.word) {
        const query = !this.$route.query.current ? {
          current: this.$route.name
        } : {
          current: this.$route.query.current
        }

        this.$router.push({
          name: 'NewsroomSearch',
          params: {
            locale: this.$route.params.locale
          },
          query: {
            ...query,
            word: this.word,
            report: 1,
            media: 1,
            fact: 1,
          }
        }).catch(e => {})

        this.$refs.search.blur()
      } else {
        this.onRemoveWord()
      }
    },
    onRemoveWord () {
      this.word = ''

      this.$refs.search.focus()

      this.$router.push({
        name: this.$route.query.current ? this.$route.query.current : 'Newsroom',
        params: {
          locale: this.$route.params.locale
        },
        query: { page: 1 }
      }).catch(e => {})
    },
    detectMobileDevice (agent) {
      const mobileRegex = [
        /Android/i,
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /BlackBerry/i,
        /Windows Phone/i
      ]

      return mobileRegex.some(mobile => agent.match(mobile))
    }
  }
}
</script>
